import React from 'react';
import { View } from './tw-wrappers';

interface ProgressBarPrimitiveProps {
  value: number; // 0-100
  height?: number;
  color?: string;
  backgroundColor?: string;
}

export const ProgressBarPrimitive = ({
  value,
  height = 10,
  color = '#FACC15',
  backgroundColor = '#E5E7EB',
}: ProgressBarPrimitiveProps) => {
  const clampedValue = Math.min(100, Math.max(0, value));
  const borderRadius = height / 2;

  return (
    <View className="relative w-full">
      {/* Track */}
      <View
        style={{ height, borderRadius, backgroundColor }}
        className="w-full"
      />

      {/* Fill */}
      <View
        style={{
          height,
          borderRadius,
          backgroundColor: color,
          width: `${clampedValue}%`,
          position: 'absolute',
          top: 0,
          left: 0
        }}
      />
    </View>
  );
};
